import React from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { FormControl, TextField, FormHelperText } from '@mui/material';
import SecureComponent from '../SecureComponent';

class TextInput extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)//if store's value relative to this component change, update the state value
            this.setState({ error: newProps.error });
        else if (!newProps.error)//in case the store does not have any value for this component, just clear it
            this.setState({ error: "" });
    }

    onChange = (event) => {
        const value = event.target.value;
        let newValue = value;
        if (this.props.type === 'number') {
            const reg = /\d+/g;
            const numbers = value.match(reg);
            newValue = numbers ? numbers.join('') : '';
        }
        this.setState({ value: newValue });
        this.updateStore(newValue);

        if (this.props.onChange){
            this.props.onChange(event);
        }
    }

    onKeyPress = (e) => {
        if (e.keyCode === 13 && this.props.onPressKey != undefined) {
            this.props.onPressKey();
        }
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    updateStore(value) {
        // const error = this.validate(value);
        this.setState({ value });
        this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });
    }

    validate(value) {
        const p = this.props;
        let error = null;
        // console.log(p);
        if (!value && p.required)
            error = p.errorMsg ? p.errorMsg : p.name + ' is required';
        if (value && p.pattern) {
            let patt = new RegExp(p.pattern);
            if (!patt.test(value))
                error = p.patternErrorMsg ? p.patternErrorMsg : p.name + ' is invalid';
        }
        return error;
    }

    render() {
        const p = this.props;
        const s = this.state;
        const localError = this.state && this.state.error;
        const value = this.state && this.state.value;
        const { userAutorizationLevel, className, type, error, dispatch, patternErrorMsg, defaultValue, pattern,id, startAdornment, endAdornment, ...textProps } = this.props;
        if (!s.authorized) return null;

        return (
            <div className="form-group TextInput">
                <FormControl className={`${p.className} ${Boolean(localError) && value.length === 0 ? 'error' : ``}`} error={Boolean(localError)} fullWidth>
                    <TextField 
                        {...textProps}
                        InputLabelProps={{ shrink: true }}
                        type={p.type === 'number' ? 'text' : p.type}
                        inputProps={{
                            minLength: p.minLength || 0,
                            maxLength: p.maxLength || 250
                        }}
                        InputProps={{
                            startAdornment: p.startAdornment || null,
                            endAdornment: p.endAdornment || null,
                        }}
                        value={this.state.value || ""}
                        onChange={e => this.onChange(e)}
                        onBlur={this.onBlur}
                        onKeyDown={(e) => this.onKeyPress(e)}
                        className={this.className}
                        variant='standard'
                        label={p.floatingLabelText || p.label}
                        placeholder={p.hintText}
                        id={p.id || p.name}
                    />
                    {localError && value.length === 0 ? <FormHelperText>{localError}</FormHelperText> : null}
                </FormControl>
            </div>
        );
    }
}

// mapStateToProps to get state from Redux store
const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel
    };
};

export default connect(mapStateToProps)(TextInput);
